<template>
  <!-- 商品详情 -->
  <div class="index-container" v-loading="loading">
    <div class="banner" :style="{ backgroundImage: 'url( ' + bannerImg + ')' }">
      <div class="index-title">商品详情</div>
    </div>
    <div class="index-content">
      <div class="nav-box">
        首页 > 柏瑞康书斋
        <span>> 商品详细</span>
      </div>
      <div class="module-box">
        <div
          class="left-img"
          :style="{ backgroundImage: 'url( ' + imgUrl + detailInfo.thumb + ')' }"
        ></div>
        <div class="right-info">
          <div class="info-title">{{detailInfo.title}}</div>
          <div class="detail-box">
            <div class="d-list">
              <div class="list-name">课程评分</div>
              <div class="list-words">
                {{detailInfo.evaluate_avg}}
                <span>（{{detailInfo.count_evaluate}}人评价）</span>
              </div>
            </div>
            <div class="d-list">
              <div class="list-name">课程类别</div>
              <div class="list-words">{{detailInfo['cate_name']}}</div>
            </div>
            <div class="d-list">
              <div class="list-name">销量</div>
              <div class="list-words">{{detailInfo.sale}}</div>
            </div>
          </div>
          <!-- <div class="intro-title">简介</div>
          <div class="intro-words">{{detailInfo.detail?detailInfo.detail:'暂无'}}</div>-->
          <div class="button-box">
            <div class="btn" @click="buy">立即购买</div>
            <div class="btn" @click="goShopCart">加入购物车</div>
          </div>
        </div>
      </div>
      <div class="summarize-content">
        <div class="cart-box" @click="goCart">
          <div class="cart-img" :style="{ backgroundImage: 'url( ' + cartImg + ')' }"></div>
          <div class="cart-text">购物车</div>
        </div>
        <div class="left-summarize">
          <div class="left-module">
            <div class="tab-box">
              <div
                @click="tabSelect(index)"
                class="tab-list"
                :class="tabIndex === index?'tab-active':''"
                v-for="(item,index) in tabList"
                :key="'tab' + index"
              >{{item}}</div>
            </div>
            <div class="detail-words" v-html="tabIndex === 0?detailInfo.desc:detailInfo.after_sale"></div>
            <!-- <div class="img-box">
              <div class="img-list" v-for="(item, index) in imgList" :key="'img' + index">{{ item }}</div>
              <i class="iconfont-icon icon-youjiantou-tianchong"></i>
            </div>-->
          </div>
          <div class="comment-module">
            <div class="d-title">用户评论（{{listTotal}}）</div>
            <div class="comment-box">
              <div
                class="comment-list"
                v-for="(item, index) in commentList"
                :key="'comment' +index"
              >
                <template v-if="item.user && item['user']['avatar']">
                  <div
                    class="c-img"
                    :style="{ backgroundImage: 'url( ' + imgUrl + item['user']['avatar'] + ')' }"
                  ></div>
                </template>
                <template v-else>
                  <div class="c-img"></div>
                </template>
                <div class="right-info">
                  <div class="c-name">
                    {{item['user']?item['user']['real_name']:'暂无'}}
                    <!-- <span>{{item.date}}</span> -->
                  </div>
                  <el-rate v-model="item.evaluate" disabled :colors="scoreColor"></el-rate>
                  <div class="c-words">{{item.detail?item.detail:'默认好评'}}</div>
                  <div class="img-box" v-if="item.imgs">
                    <div
                      @click="lookCard(ele)"
                      class="img-list"
                      v-for="(ele,idx) in item.imgs"
                      :key="idx"
                      :style="{
                      backgroundImage: 'url( ' + imgUrl + ele + ')'
                    }"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <el-pagination
              @current-change="handleCurrentChange"
              background
              layout="prev, pager, next"
              :page-size="page_size"
              :total="listTotal"
            ></el-pagination>
          </div>
        </div>
        <div class="right-list-box">
          <div class="d-title">推荐教材</div>
          <div
            class="course-list"
            @click="goCommodityDetail(item,index)"
            v-for="(item, index) in detailInfo.recommend"
            :key="index"
          >
            <div class="c-img" :style="{ backgroundImage: 'url( ' + imgUrl +  item.thumb + ')' }"></div>
            <div class="c-content">
              <div class="c-title">{{ item.title }}</div>
              <!-- <div class="c-box">
                <div class="c-price">
                  <span>¥</span>
                  {{ item.price }}
                </div>
                {{ item.sale }}人已购买
              </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 查看图片 -->
    <el-dialog class="form-box" :visible.sync="dialogVisible" width="600PX">
      <div class="dialog-img" :style="{ backgroundImage: 'url( ' + imgUrl + imgInfo + ')' }"></div>
    </el-dialog>
  </div>
</template>
<script>
import banner from '@/assets/img/bairuizhai_banner.png';
import cart from '@/assets/img/cartfull_icon.png';
import api from '../api/api';
import { imgUrl } from '../api/index';

export default {
  name: 'commodityDetail',
  data() {
    return {
      imgUrl: imgUrl,
      bannerImg: banner,
      cartImg: cart,
      courseList: [],
      tabList: ['商品概述', '售后说明'],
      tabIndex: 0,
      imgList: ['', '', ''],
      scoreColor: ['#FF9C00', '#FF9C00', '#FF9C00', '#FF9C00', '#FF9C00'],
      commentList: [],
      listTotal: 0,
      page_index: 1,
      detailId: '',
      page_size: 5,
      detailInfo: {},
      imgInfo: '',
      dialogVisible: false,
      loading: true
    };
  },

  mounted() {
    scrollTo(0, 0);
  },
  created() {
    const value = this.$route.query;
    console.log(value);
    if (value) {
      this.getDetail(value.id);
      this.detailId = value.id;
      this.getShopComment();
    }
  },
  methods: {
    // 跳转商品详情
    goCommodityDetail(item, index) {
      console.log(item);
      this.$router.push({ path: 'commodityDetail', query: { id: item.uuid } });
    },
    lookCard(item) {
      this.imgInfo = item;
      this.dialogVisible = true;
    },
    tabSelect(index) {
      this.tabIndex = index;
    },
    //   获取详情
    getDetail(id) {
      api.getShopDetail({ uuid: id }).then(res => {
        console.log(res);
        if (res.result) {
          this.detailInfo = res.result;
          this.detailInfo.desc = this.changeShowImg(this.detailInfo.desc);
          this.detailInfo.after_sale = this.changeShowImg(
            this.detailInfo.after_sale
          );
          this.loading = false;
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    changeShowImg(obj) {
      const baseImg = 'https://train-service-api.procaregroup.com/';
      const objstr = JSON.stringify(obj);
      const midStr = 'train_service/app_upload';
      const str = objstr.replace(new RegExp(baseImg, 'g'), '');
      const str1 = str.replace(
        new RegExp(midStr, 'g'),
        'https://train-service-api.procaregroup.com/train_service/app_upload'
      );
      return JSON.parse(str1);
    },
    handleCurrentChange(val) {
      this.page_index = val;
      this.getShopComment();
    },
    // 获取评论
    getShopComment() {
      const params = {
        good_uuid: this.detailId,
        page_index: this.page_index,
        page_size: this.page_size
      };
      api.getShopComment(params).then(res => {
        console.log(res);
        if (res.result) {
          this.commentList =
            res.result.data && res.result.data.length > 0
              ? res.result.data
              : [];
          console.log(this.commentList);
          this.listTotal = res.result.total;
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    // 加入购物车
    goShopCart() {
      const params = {
        good_uuid: this.detailInfo.uuid,
        stock: 1,
        is_add: 1
      };
      api.addCart(params).then(res => {
        console.log(res);
        if (res.result) {
          this.$message.success('加入成功！');
          //   this.$router.push({ path: 'shoppingCart' });
        } else {
          // this.$message.warning(res.message);
          this.$message.warning('请登录！');
          location.reload();
        }
      });
    },
    // 跳转至购物车
    goCart() {
      const isLogin = localStorage.getItem('X-Access-Token');
      console.log(isLogin);
      if (!isLogin) {
        this.$message.warning('请登录！');
        location.reload();
        return;
      }
      this.$router.push({
        path: 'shoppingCart',
        query: { id: this.detailInfo.uuid }
      });
    },
    // 立即购买
    buy() {
      const isLogin = localStorage.getItem('X-Access-Token');
      console.log(isLogin);
      if (!isLogin) {
        this.$message.warning('请登录！');
        location.reload();
        return;
      }
      this.getGoodOrder();
    },
    // 获取订单编号
    getGoodOrder() {
      const params = {
        goods: this.detailInfo.uuid,
        create_type: 1
      };
      api.getGoodOrder(params).then(res => {
        console.log(res);
        if (res.result) {
          this.$router.push({
            path: '/shoppingPay',
            query: { order_sn: res.result.order_sn }
          });
        } else {
          this.$message.warning(res.message);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.index-container {
  margin-top: 122PX;
  background-color: #f8f7f6;
  .banner {
    position: relative;
    width: 100%;
    height: 492PX;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .index-title {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 20%;
    font-size: 56PX;
    color: #ffffff;
  }
}
.index-content {
  width: 72%;
  padding: 60PX 0 150PX;
  margin: 0 auto;
}
.nav-box {
  padding-bottom: 40PX;
  font-size: 16PX;
  color: #333333;
  span {
    color: #7d7d7d;
  }
}
.module-box {
  display: flex;
  padding: 46PX 20PX;
  margin-bottom: 24PX;
  background-color: #ffffff;
  .left-img {
    width: 285PX;
    height: 285PX;
    background-color: wheat;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .right-info {
    position: relative;
    flex: 1;
    padding: 10PX 0 0 40PX;
  }
  .info-title {
    padding-bottom: 22PX;
    font-size: 26PX;
    color: #333333;
    font-weight: bold;
  }
  .detail-box {
    display: flex;
    margin-bottom: 8PX;
  }
  .d-list {
    margin-right: 50PX;
  }
  .list-name {
    position: relative;
    padding: 0 0 8PX 10PX;
    &::before {
      position: absolute;
      top: 4PX;
      left: 0;
      width: 3PX;
      height: 12PX;
      background: #f1a373;
      border-radius: 2PX;
      content: '';
    }
  }
  .list-words {
    padding-left: 10PX;
    font-size: 16PX;
    color: #f1a373;
    span {
      font-size: 14PX;
    }
  }
  .intro-title {
    line-height: 24PX;
  }
  .intro-words {
    width: 70%;
    margin-bottom: 18PX;
    color: #666666;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .button-box {
    position: absolute;
    bottom: 0;
    display: flex;
    .btn {
      width: 120PX;
      margin-right: 20PX;
      color: #ffffff;
      line-height: 42PX;
      text-align: center;
      background: #f1a373;
      border: 1PX solid #f1a373;
      border-radius: 45PX;
      cursor: pointer;
      &:last-child {
        color: #f1a373;
        background: #ffffff;
      }
    }
  }
}
.summarize-content {
  position: relative;
  display: flex;
  justify-content: space-between;
  .cart-box {
    position: absolute;
    z-index: 99;
    right: 0;
    top: 30%;
    transform: translateY(-50%);
    width: 112PX;
    height: 112PX;
    padding-top: 22PX;
    color: #f1a373;
    text-align: center;
    background: #ffffff;
    box-shadow: 0PX -5PX 6PX 0PX rgba(223, 223, 223, 0.5),
      0PX 2PX 4PX 0PX rgba(191, 191, 191, 0.5);
    border-radius: 50%;
    cursor: pointer;
  }
  .cart-img {
    width: 48PX;
    height: 48PX;
    margin: 0 auto 4PX 30PX;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }
}
.left-summarize {
  width: 67%;
  .left-module {
    padding: 25PX;
    margin-bottom: 26PX;
    background-color: #ffffff;
  }
  .tab-box {
    display: flex;
    margin-bottom: 25PX;
    border-bottom: 1PX solid #ececec;
  }
  .tab-list {
    position: relative;
    font-size: 20PX;
    color: #666666;
    padding-bottom: 16PX;
    margin-right: 45PX;
    cursor: pointer;
    &:hover {
      color: #f1a373;
      &::after {
        background-color: #f1a373;
      }
    }
    &::after {
      position: absolute;
      left: 12PX;
      bottom: 0;
      width: 55PX;
      height: 3PX;
      background-color: transparent;
      content: '';
    }
  }
  .tab-active {
    color: #f1a373;
    &::after {
      background-color: #f1a373;
    }
  }
  .detail-words {
    padding-bottom: 38PX;
    font-size: 16PX;
    line-height: 24PX;
  }
  .img-box {
    display: flex;
    align-items: center;
    .img-list {
      width: 228PX;
      height: 152PX;
      margin-right: 30PX;
      background-color: #eeeeee;
    }
    .iconfont-icon {
      margin-left: 30PX;
      font-size: 60PX;
      color: #f1a373;
      cursor: pointer;
    }
  }
}
.d-title {
  position: relative;
  padding-bottom: 16PX;
  margin-bottom: 45PX;
  font-size: 20PX;
  color: #f1a373;
  border-bottom: 1PX solid #ececec;
  &::after {
    position: absolute;
    left: 12PX;
    bottom: 0;
    width: 55PX;
    height: 3PX;
    background-color: #f1a373;
    content: '';
  }
}
/deep/ {
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #fb6d0a;
  }
  .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #ffffff;
    background-color: #fb6d0a;
  }
  .el-pagination {
    padding-bottom: 80PX;
    text-align: center;
    button {
      width: 42PX;
      height: 42PX;
    }
  }
  .el-pager li {
    width: 42PX;
    height: 42PX;
    line-height: 42PX;
  }
}
.comment-module {
  padding: 25PX;
  background-color: #ffffff;
  .comment-box {
    padding: 0 0 48PX;
  }
  .comment-list {
    display: flex;
    margin-bottom: 20PX;
  }
  .c-img {
    width: 64PX;
    height: 64PX;
    background-color: wheat;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 50%;
  }
  .right-info {
    flex: 1;
    padding-left: 22PX;
  }
  .c-name {
    font-size: 16PX;
    font-weight: bold;
    span {
      float: right;
      font-size: 14PX;
      color: #999999;
      font-weight: normal;
    }
  }
  .c-words {
    margin-bottom: 20PX;
    padding-top: 10PX;
    line-height: 24PX;
  }
  .img-box {
    display: flex;
  }
  .img-list {
    width: 33%;
    cursor: pointer;
  }
}
.right-list-box {
  width: 31%;
  padding: 25PX;
  background-color: #ffffff;
}
.course-list {
  margin-bottom: 30PX;
  cursor: pointer;
  &:hover {
    .c-title {
      color: #fb6d0a;
    }
  }
  .c-img {
    height: 220PX;
    background-color: #ececec;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .c-content {
    padding: 14PX 16PX;
    border: 1PX solid #ededed;
    border-top: none;
  }
  .c-title {
    padding-bottom: 6PX;
  }
  .c-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12PX;
    color: #888888;
  }
  .c-price {
    font-size: 22PX;
    color: #dd0707;
    font-weight: 600;
    span {
      font-size: 14PX;
    }
  }
}
.dialog-img {
  width: 90%;
  height: 445PX;
  margin: 0 auto 26PX;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
</style>



// WEBPACK FOOTER //
// src/views/commodityDetail.vue